// @ts-ignore
export { Curtains, Plane, Vec2 } from "curtainsjs";

const VertexShader = require('./VertexShader.glsl');
const FragmentShader = require('./FragmentShader.glsl');

const DEFAULT_DELTAS = {
    max: 0,
    applied: 0,
}

export { VertexShader, FragmentShader, DEFAULT_DELTAS }